import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadnav-component',
  templateUrl: './breadnav-component.component.html',
  styleUrls: ['./breadnav-component.component.css']
})
export class BreadnavComponentComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    debugger;
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Sainik Registration')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/breadnav-component/breadnav-component.component.ts